import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';

@Directive({
    selector: '[appValueIsValidFn]',
    providers: [{provide: NG_VALIDATORS, useExisting: ValidatorFnDirective, multi: true}]
})
export class ValidatorFnDirective implements Validator {

    @Input() appValueIsValidFn: (value: any )  => boolean;

    constructor() {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return this.validateValue(control);
    }

    private validateValue(control: AbstractControl)  {
        return  this.appValueIsValidFn(control.value) ? null : {appValueIsValidFn: true} ;
    }
}
